import { AbstractGetAllStore } from "../common/AbstractStores";
import { BruciatoreDto } from "../generated";
import Dispatcher from "../common/dispatcher";
import Actions from "./bruciatoriActions";

class BruciatoriStore extends AbstractGetAllStore<BruciatoreDto>{
    constructor() {
        super(x => x.idBruciatore.toString());
        Dispatcher
            .onfunction(Actions.getAll, result => this.setAll(result!))
            .onfunction(Actions.getbruciatore, result => this.updateOrAdd(result!))
            .onfunction(Actions.add, result => this.add(result))
            .onfunction(Actions.update, result => this.update(result))
    }

    public use(id: number | null) {
        return this.useWithAction(() => id && Actions.getbruciatore(id), id?.toString() ?? null)
    }
    public useAll() {
        return this.useAllWithAction(() => Actions.getAll())
    }
}

export default new BruciatoriStore()